import React, { useEffect, useRef, useState, lazy, Suspense } from "react";
import { Route, Routes, useLocation, matchPath } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { HelmetProvider } from "react-helmet-async";

// Static Layout & Critical Components (Non-lazy)
import Homepage from "./page/Homepages/Homepage";
import HeaderOne from "./page/HomePageNew/HeaderOne";
import ScrollToTop from "./page/HomePageNew/hooks/ScrollToTop";
import MouseMove from "./components/MouseMove";
import Whatsappicon from "./page/Whatsappicon";
import { ChatBotComponent } from "./chatBot/chatBotComponents";
import ModalComponent from "./components/ModalComponent";
import CanonicalTag from "./components/CanonicalTag";

// Lazy Loaded Components
const About = lazy(() => import("./page/About"));
const Career = lazy(() => import("./page/Career"));
const Contact = lazy(() => import("./page/Contact"));
const Faq = lazy(() => import("./page/Faq"));
const Portfolio = lazy(() => import("./page/Portfolio"));
const DigitalMarketing = lazy(
  () => import("./components/Service/DigitalMarketing"),
);
const Graphic = lazy(() => import("./components/Service/Graphic"));
const Mobiledevelopment = lazy(
  () => import("./components/Service/Mobiledevolopment"),
);
const Ppc = lazy(() => import("./components/Service/Ppc"));
const SEO = lazy(() => import("./components/Service/SEONew"));
const Smm = lazy(() => import("./components/Service/Smm"));
const Web = lazy(() => import("./components/Service/Web"));
const VettedDevelopers = lazy(
  () => import("./components/Service/VettedDevelopers"),
);
const AIAutomation = lazy(() => import("./components/Service/AIAutomation.js"));
const WhatsappBulk = lazy(() => import("./components/Service/WhatappBulk.js"));
const SMSBulk = lazy(() => import("./components/Service/SMSBulk.js"));
const Service = lazy(() => import("./page/Homepages/Service"));
const Blogs = lazy(() => import("./page/Blogs"));
const Case_Studies = lazy(() => import("./page/Case_Studies"));
const Sitemap = lazy(() => import("./page/Sitepmap"));
const Dentalguru = lazy(() => import("./page/Dentalguru"));
const Blog1 = lazy(() => import("./components/blogs/Blog1"));
const Blog2 = lazy(() => import("./components/blogs/Blog2"));
const Blog3 = lazy(() => import("./components/blogs/Blog3"));
const Blog4 = lazy(() => import("./components/blogs/Blog4"));
const Blog5 = lazy(() => import("./components/blogs/Blog5"));
const Pr_Service = lazy(() => import("./components/Service/Pr_Service"));
const Blog6 = lazy(() => import("./components/blogs/Blog6"));
const Terms = lazy(() => import("./components/Terms&Condition/Terms"));
const Privacy = lazy(() => import("./components/Terms&Condition/Privacy"));
const Refund = lazy(() => import("./components/Terms&Condition/Refund"));
const Blog7 = lazy(() => import("./components/blogs/Blog7"));
const Blog8 = lazy(() => import("./components/blogs/Blog8"));
const Blog9 = lazy(() => import("./components/blogs/Blog9"));
const Webbased = lazy(() => import("./page/Portfoliov1/Webbased"));
const Animation = lazy(() => import("./page/Portfoliov1/Animation"));
const Softwares = lazy(() => import("./page/Portfoliov1/Softwares"));
const Smosmm = lazy(() => import("./page/Portfoliov1/Smosmm"));
const F404page = lazy(() => import("./page/F404page"));
const CareerAdmin = lazy(() => import("./AdminDashBoard/CareerAdmin"));
const ContactAdmin = lazy(() => import("./AdminDashBoard/ContactAdmin"));
const ContactAdminSEO = lazy(() => import("./AdminDashBoard/ContactAdminSEO"));
const UserSign = lazy(() => import("./AdminDashBoard/UserSign"));
const AdminLogin = lazy(() => import("./AdminDashBoard/AdminLogin"));
const Blog10 = lazy(() => import("./components/blogs/Blog10"));
const Blog11Page = lazy(() => import("./components/blogs/Blog11"));
const Blog12Page = lazy(() => import("./components/blogs/Blog12"));
const MiniDentalguru = lazy(() => import("./page/MiniDentalGuru"));
const QuotationGenerator = lazy(() =>
  import("./page/QuotationGenerator").then((m) => ({
    default: m.QuotationGenerator,
  })),
);
const DGCrm = lazy(() =>
  import("./page/DGCRM").then((m) => ({ default: m.DGCrm })),
);
const Blog13Page = lazy(() => import("./components/blogs/Blog13"));
const InitiateCheckoutPage = lazy(
  () => import("./page/PaymentGatewayPages/InitiateCheckoutPage"),
);
const AddToCartPage = lazy(
  () => import("./page/PaymentGatewayPages/AddToCartPage"),
);
const PaymentPage = lazy(
  () => import("./page/PaymentGatewayPages/PaymentPage"),
);
const Blog14Page = lazy(() => import("./components/blogs/Blog14"));
const Blog15Page = lazy(() => import("./components/blogs/Blog15"));
const Blog16Page = lazy(() => import("./components/blogs/Blog16"));
const Blog17Page = lazy(() => import("./components/blogs/Blog17"));
const Blog18Page = lazy(() => import("./components/blogs/Blog18"));
const Blog19Page = lazy(() => import("./components/blogs/Blog19"));
const Blog20Page = lazy(() => import("./components/blogs/Blog20"));
const Blog21Page = lazy(() =>
  import("./components/blogs/Blog21").then((m) => ({ default: m.Blog21Page })),
);
const Blog22Page = lazy(() =>
  import("./components/blogs/Blog22").then((m) => ({ default: m.Blog22Page })),
);
const Blog23Page = lazy(() =>
  import("./components/blogs/Blog23").then((m) => ({ default: m.Blog23Page })),
);
const Blog24Page = lazy(() =>
  import("./components/blogs/Blog24").then((m) => ({ default: m.Blog24Page })),
);
const Blog25Page = lazy(() =>
  import("./components/blogs/Blog25").then((m) => ({ default: m.Blog25Page })),
);
const Blog26Page = lazy(() => import("./components/blogs/Blog26"));
const Blog27Page = lazy(() =>
  import("./components/blogs/Blog27").then((m) => ({ default: m.Blog27Page })),
);
const Blog28Page = lazy(() =>
  import("./components/blogs/Blog28").then((m) => ({ default: m.Blog28Page })),
);
const Blog29Page = lazy(() =>
  import("./components/blogs/Blog29").then((m) => ({ default: m.Blog29Page })),
);
const TextEditor = lazy(() => import("./components/Editor"));
const Blog30Page = lazy(() =>
  import("./components/blogs/Blog30").then((m) => ({ default: m.Blog30Page })),
);
const Blog31Page = lazy(() =>
  import("./components/blogs/Blog31").then((m) => ({ default: m.Blog31Page })),
);
const Blog32Page = lazy(() =>
  import("./components/blogs/Blog32").then((m) => ({ default: m.Blog32Page })),
);
const Blog33Page = lazy(() =>
  import("./components/blogs/Blog33").then((m) => ({ default: m.Blog33Page })),
);
const Blog34Page = lazy(() =>
  import("./components/blogs/Blog34").then((m) => ({ default: m.Blog34Page })),
);
const Blog35Page = lazy(() =>
  import("./components/blogs/Blog35").then((m) => ({ default: m.Blog35Page })),
);
const YouTubeVideos = lazy(() => import("./components/blogs/YouTubeVideos"));
const AdminBlogList = lazy(() => import("./AdminDashBoard/AdminBlogList"));
const AdminBlogForm = lazy(() => import("./AdminDashBoard/AdminBlogForm"));
const MedBrainixBlogForm = lazy(() => import("./AdminDashBoard/MedBrainixBlogForm"));
const MedBrainixBlogList = lazy(() => import("./AdminDashBoard/MedBrainixBlogList"));
const BlogList = lazy(() => import("./components/blogs/BlogList"));
const BlogDetail = lazy(() => import("./components/blogs/BlogDetail"));
const AddAnimation = lazy(() => import("./AdminDashBoard/AddAnimation"));
const PortfolioList = lazy(() => import("./AdminDashBoard/PortfolioList"));
const EditAnimation = lazy(() => import("./AdminDashBoard/EditAnimation"));
const AddWebbased = lazy(() => import("./AdminDashBoard/AddWebbased"));
const EditWebbased = lazy(() => import("./AdminDashBoard/EditWebbased"));
const AddSoftware = lazy(() => import("./AdminDashBoard/AddSoftware"));
const EditSoftware = lazy(() => import("./AdminDashBoard/EditSoftware"));
const AddSMO = lazy(() => import("./AdminDashBoard/AddSMO"));
const DigitalMarketingPortfolio = lazy(
  () => import("./page/Portfoliov1/DigitalMarketing"),
);
const CrmContact = lazy(() => import("./AdminDashBoard/CrmContact"));
const CaseStudyGrid = lazy(() => import("./page/Portfoliov1/CaseStudy"));
const AddDigitalMarketing = lazy(
  () => import("./AdminDashBoard/AddDigitalMarketing"),
);
const EditDigitalMarketing = lazy(
  () => import("./AdminDashBoard/EditDigitalMarketing"),
);
const DataAnalysis = lazy(() => import("./components/Service/DataAnalysis"));
const ServiceNew = lazy(() => import("./page/ServiceNew"));
const ThankYouPage = lazy(() => import("./page/ThankYou"));
const DentalguruLeads = lazy(() => import("./AdminDashBoard/DentalguruLeads"));
const TopSeoCompanies = lazy(() => import("./AdminDashBoard/MetroCities"));
const CityPage = lazy(() => import("./AdminDashBoard/Citypage"));
const DelhiSEO = lazy(() => import("./AdminDashBoard/Delhipage"));
const MumbaiSEO = lazy(() => import("./AdminDashBoard/Mumbaipage"));
const PuneSEO = lazy(() => import("./AdminDashBoard/Punepage"));
const BangaloreSEO = lazy(() => import("./AdminDashBoard/Bangalorepage"));
const IndoreSEO = lazy(() => import("./AdminDashBoard/Indorepage"));
const NoidaSEO = lazy(() => import("./AdminDashBoard/Noidapage"));
const SEOCountries = lazy(() => import("./AdminDashBoard/Countries"));
const CountriesPage = lazy(() => import("./AdminDashBoard/Coutriespage"));
const UKSEO = lazy(() => import("./AdminDashBoard/UKpage"));
const USASEO = lazy(() => import("./AdminDashBoard/USApage.jsx"));
const DUBAIASEO = lazy(() => import("./AdminDashBoard/DUBAIpage.jsx"));
const AUSTRALIASEO = lazy(() => import("./AdminDashBoard/Australiapage.jsx"));
const UAESEO = lazy(() => import("./AdminDashBoard/UAEpage.jsx"));
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

function App() {
  const user = useSelector((state) => state.user);
  const isAdmin = user?.currentUser !== null || localStorage.getItem("adminLoggedIn") === "true";
  let [toggleBtn, setToggelBtn] = useState(true);

  // not show navbar in this routes
  const location = useLocation();
  const hiddenNavbarRoutes = [
    "/Admin-Login",
    "/Admin-Page-Career",
    "/Admin-Page-Contact",
    "/Admin-Page-CRMContact",
    "/Admin-Page-UserSign",
    "/manage-medbrainix-blogs",
    "/medbrainix-blogs/newAdd",
    "/AdminAdd-blogs",
    "blogs/newAdd",
    "/Updateblog/:id",
    "/Admin-portfolio",
    "/Admin-portfolio-add-animation",
    "/UpdateAnimation/:id",
    "/Admin-portfolio-add-webbased",
    "/Admin-portfolio-add-digital-marketing",
    "/update-digital-marketing/:id",
    "/UpdateWebbased/:id",
    "/Admin-portfolio-add-softwares",
    "/Updatesoftware/:id",
    "/Admin-portfolio-add-SMO-SMM",
    "/UpdateSMO-SMM/:id",
    "/admin-page-dentalguru-leads",
  ];

  // const shouldHideNavbar = hiddenNavbarRoutes.includes(location.pathname);

  const shouldHideNavbar = hiddenNavbarRoutes.some((pattern) =>
    matchPath({ path: pattern, end: false }, location.pathname),
  );

  const smootherContainer = useRef(null);
  const content = useRef(null);
  useEffect(() => {
    let smoother = ScrollSmoother.create({
      wrapper: smootherContainer.current,
      content: content.current,
      smooth: 2, // Try 2 or even 2.5 for super smooth
      normalizeScroll: true, // Normalize different scroll behaviors
      ignoreMobileResize: true,
      effects: true,
    });

    return () => {
      smoother.kill();
    };
  }, []);

  let protecteApi = async (z) => {
    try {
      let data = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/protected/${z}`,
      );
      let { user } = data.data;
      if (user) {
        setToggelBtn(false);
      } else {
        setToggelBtn(true);
      }
    } catch (error) {
      // protected API not available or token invalid - ignore silently
    }
  };

  let FechAuth = () => {
    let token = localStorage.getItem("token");
    if (token?.length > 0) {
      protecteApi(token);
    } else {
      protecteApi("null");
    }
  };

  useEffect(() => {
    FechAuth();
  }, []);

  // seoformAPI

  // modal

  const { pathname } = useLocation();
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    localStorage.setItem("formSubmitted", "true");
  };

  const handleShow = () => setShowModal(true);

  // useEffect(() => {
  //   // Show modal only on the Homepage
  //   if (pathname === "/") {
  //     const timer = setTimeout(() => {
  //       handleShow();
  //     }, 5000);

  //     return () => clearTimeout(timer);
  //   } else {
  //     setShowModal(false);
  //   }
  // }, [pathname]);

  useEffect(() => {
    // Use GSAP ScrollSmoother if available, otherwise fallback to window.scrollTo
    if (window.ScrollSmoother && window.ScrollSmoother.get) {
      const smoother = window.ScrollSmoother.get();
      if (smoother && typeof smoother.scrollTo === "function") {
        smoother.scrollTo(0, true);
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  const handleFormSubmit = () => {
    handleClose(); // Close the modal
  };

  return (
    <HelmetProvider>
      <CanonicalTag />
      <>
        {showModal && (
        <ModalComponent
          show={showModal}
          handleClose={handleClose}
          onSubmit={handleFormSubmit}
        />
      )}
      {!shouldHideNavbar && <HeaderOne />}
      <div style={{ overflow: "hidden" }}>
        <div ref={smootherContainer} id="smooth-wrapper">
          <div ref={content} id="smooth-content">
            <Suspense
              fallback={
                <div
                  className="loading-spinner"
                  style={{
                    padding: "100px",
                    textAlign: "center",
                    fontSize: "1.3rem",
                    color: "#fe7604",
                    fontWeight: "600",
                  }}>
                  Loading...
                </div>
              }>
              <Routes>
                <Route path="/" Component={Homepage} />
                <Route path="/about_us" Component={About} />
                <Route path="/career" Component={Career} />
                <Route path="/contact_us" Component={Contact} />
                <Route path="/faq" Component={Faq} />
                <Route
                  path="/Best-Digital-Marketing-Company-India"
                  Component={DigitalMarketing}
                />
                <Route
                  path="/Best-Software-Company-In-Jabalpur"
                  Component={Web}
                />
                <Route path="/graphic-designing" Component={Graphic} />
                <Route
                  path="/mobile-development"
                  Component={Mobiledevelopment}
                />
                <Route path="/data-analysis" Component={DataAnalysis} />

                <Route path="/ppc" Component={Ppc} />
                <Route path="/seo-services-india" Component={SEO} />
                <Route path="/thankYou" element={<ThankYouPage />} />
                <Route
                  path="/Best-social-media-marketing-company-in-Jabalpur-India"
                  Component={Smm}
                />
                <Route
                  path="/Best-Software-Company-in-Jabalpur"
                  Component={Web}
                />
                <Route
                  path="/vetted-developers-in-india"
                  Component={VettedDevelopers}
                />
                <Route
                  path="/ai-automation-services-India"
                  Component={AIAutomation}
                />
                <Route
                  path="/bulk-whatsapp-marketing-service"
                  Component={WhatsappBulk}
                />
                <Route path="/bulk-sms-service" Component={SMSBulk} />
                <Route path="/services" Component={ServiceNew} />
                <Route path="/blogs" Component={Blogs} />
                <Route
                  path="/10-Essential-Skills-Every-Digital-Marketer-Needs-to-Know"
                  Component={Blog1}
                />
                <Route
                  path="/Optimizing-Your-Business-Because-Google-Can't-Read-Your-Mind-Yet"
                  Component={Blog2}
                />
                <Route
                  path="/Email-Marketing-Because-Your-Inbox-Was-Feeling-Lonely"
                  Component={Blog3}
                />
                <Route
                  path="/Unveiling-the-Secrets-of-the-Best-Graphic-Designing-Company-for-Your-Creative-Dreams!"
                  Component={Blog4}
                />
                <Route
                  path="/Best-Graphic-Designing-Company-in-Jabalpur-Elevate-Your-Brand-Presence"
                  Component={Blog5}
                />
                <Route
                  path="/Cybersecurity-Essentials-Protecting-Your-Business-in-a-Digital-Age"
                  Component={Blog6}
                />
                <Route
                  path="/The-Future-of-SEO:-Predictions-and-Strategies-for-2024"
                  Component={Blog7}
                />
                <Route
                  path="/Performance-Marketing-vs-Digital-Marketing:-Understanding-the-Key-Differences"
                  Component={Blog8}
                />
                <Route
                  path="/Best-SEO-company-in-Madhya-pradesh"
                  Component={Blog9}
                />
                <Route
                  path="/The-Best-IT-Company-in-Jabalpur-DOAGuru-Infosystems"
                  Component={Blog10}
                />
                <Route
                  path="/Best-Software-Development-Company-in-Jabalpur"
                  Component={Blog11Page}
                />
                <Route
                  path="/Best-Digital-Marketing-Company-in-Madhya-Pradesh"
                  Component={Blog12Page}
                />
                <Route
                  path="/Ultimate-Dental-Practice-Management-Software"
                  Component={Blog13Page}
                />
                <Route path="/ai-in-digital-marketing" Component={Blog14Page} />
                <Route
                  path="/Can-You-Get-a-Digital-Marketing-Job-Without-Any-Experience-?"
                  Component={Blog15Page}
                />
                <Route
                  path="/What-is-Digital-Marketing-A-Comprehensive-Guide-by-DOAGuru-InfoSystems"
                  Component={Blog16Page}
                />
                <Route
                  path="/10-Skills-You-Need-to-Become-a-Digital-Marketing-Manager"
                  Component={Blog17Page}
                />
                <Route
                  path="/How-to-Create-an-AI-Digital-Marketing-Strategy?"
                  Component={Blog18Page}
                />
                <Route
                  path="/Digital-Marketing-Career-Opportunities-in-2025"
                  Component={Blog19Page}
                />
                <Route
                  path="/DeepSeek-The-New-AI-Challenger-to-ChatGPT"
                  Component={Blog20Page}
                />
                <Route
                  path="/Digital-Marketing-Agency-in-Jabalpur"
                  Component={Blog21Page}
                />
                <Route
                  path="/Top-Digital-Marketing-Tools-for-Success-in-2025"
                  Component={Blog22Page}
                />
                <Route
                  path="/Influencer-Marketing-The-Ultimate-Guide"
                  element={<Blog23Page />}
                />
                <Route
                  path="/Should-You-Choose-a-Career-in-Digital-Marketing?"
                  element={<Blog24Page />}
                />
                <Route
                  path="/How-to-Do-a-Competitive-Analysis-in-Digital-Marketing"
                  element={<Blog25Page />}
                />
                <Route
                  path="/Best-Mobile-App-Development-in-Jabalpur"
                  element={<Blog26Page />}
                />
                <Route
                  path="/Best-Social-Media-Marketing-Agency-in-Jabalpur-DOAGuru-InfoSystems"
                  element={<Blog27Page />}
                />
                <Route
                  path="/Best-Digital-Marketing-Company-in-Indore"
                  element={<Blog28Page />}
                />
                <Route
                  path="/Best-Digital-Marketing-Company-in-Bhopal"
                  element={<Blog29Page />}
                />
                <Route
                  path="/Best-SEO-Company-in-Bhopal"
                  element={<Blog30Page />}
                />
                <Route
                  path="/Best-SEO-Company-in-Indore"
                  element={<Blog31Page />}
                />
                <Route
                  path="/Best-Website-Development-Company-in-Indore"
                  element={<Blog32Page />}
                />
                <Route
                  path="/Best-Website-Development-Company-in-Bhopal"
                  element={<Blog33Page />}
                />
                <Route
                  path="/Best-SEO-Services-Companies-in-India"
                  element={<Blog34Page />}
                />
                <Route path="/seo-company-in-India" element={<Blog35Page />} />

                {/* <Route
            path="/Best-TextEditor"
            element={<TextEditor />} /> */}

                <Route path="/blogslist" element={<BlogList />} />
                <Route path="/blogslist/:slug" element={<BlogDetail />} />
                <Route path="/blogs/:slug" element={<BlogDetail />} />
                <Route path="/youtube-videos" element={<YouTubeVideos />} />

                <Route path="/case-studies" Component={Case_Studies} />
                <Route path="/sitemap" Component={Sitemap} />
                <Route path="/dental-guru" Component={Dentalguru} />
                <Route path="/mini-dental-guru" Component={MiniDentalguru} />
                <Route
                  path="/Quotation Generator Management System"
                  Component={QuotationGenerator}
                />
                <Route path="/Doaguru CRM" Component={DGCrm} />
                <Route path="/pr-service" Component={Pr_Service} />
                <Route path="/terms-&-condition" Component={Terms} />
                <Route path="/privacy-policy" Component={Privacy} />
                <Route path="/refund-&-cancel" Component={Refund} />

                {/*------------- Payment Gateway Route ---------------*/}
                <Route
                  path="/InitiateCheckoutPage"
                  Component={InitiateCheckoutPage}
                />
                <Route path="/All-products-Page" Component={AddToCartPage} />
                <Route path="/payment" element={<PaymentPage />} />

                {/*------------- Payment Gateway Route ---------------*/}

                {/*------------- portfolio ---------------*/}
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="*" element={<F404page />} />
                {toggleBtn ? (
                  <>
                    {/* <Route path="/webbased" element={<Webbased />} />
              <Route path="/animation" element={<Animation />} />
              <Route path="/software" element={<Softwares />} />
              <Route path="/smosmm" element={<Smosmm />} />
              <Route path="/digital-marketing-portfolio" element={<DigitalMarketingPortfolio />} /> */}
                    <Route path="/portfolio-website" element={<Webbased />} />
                    <Route path="/portfolio-graphics" element={<Animation />} />
                    <Route path="/portfolio-software" element={<Softwares />} />
                    <Route path="/portfolio-smm-smo" element={<Smosmm />} />
                    <Route
                      path="/portfolio-digital-marketing"
                      element={<DigitalMarketingPortfolio />}
                    />
                    {/* <Route path="/digital-marketing-portfolio" element={<CaseStudyGrid />} /> */}
                  </>
                ) : null}
                {/*------------- portfolio-----------------*/}

                {/* *********** Admin Part Start ********* */}
                <Route path="/Admin-Login" element={<AdminLogin />} />
                <Route
                  path="/Admin-Page-Career"
                  element={
                    isAdmin ? <CareerAdmin /> : <AdminLogin />
                  }
                />
                <Route
                  path="/Admin-Page-Contact"
                  element={
                    isAdmin ? <ContactAdmin /> : <AdminLogin />
                  }
                />
                <Route
                  path="/Admin-Page-ContactSEO"
                  element={
                    isAdmin ? <ContactAdminSEO /> : <AdminLogin />
                  }
                />
                <Route
                  path="/Admin-Page-CRMContact"
                  element={
                    isAdmin ? <CrmContact /> : <AdminLogin />
                  }
                />
                <Route
                  path="/admin-page-dentalguru-leads"
                  element={
                    isAdmin ? <DentalguruLeads /> : <AdminLogin />
                  }
                />
                <Route
                  path="/Admin-Page-UserSign"
                  element={
                    isAdmin ? <UserSign /> : <AdminLogin />
                  }
                />

                <Route
                  path="/AdminAdd-blogs"
                  element={
                    isAdmin ? <AdminBlogList /> : <AdminLogin />
                  }
                />
                <Route
                  path="blogs/newAdd"
                  element={
                    isAdmin ? <AdminBlogForm /> : <AdminLogin />
                  }
                />
                <Route
                  path="Updateblog/:id"
                  element={
                    isAdmin ? <AdminBlogForm /> : <AdminLogin />
                  }
                />

                <Route
                  path="/manage-medbrainix-blogs"
                  element={
                    isAdmin ? <MedBrainixBlogList /> : <AdminLogin />
                  }
                />

                {/* MedBrainix Blog Routes */}
                <Route
                  path="medbrainix-blogs/newAdd"
                  element={
                    isAdmin ? <MedBrainixBlogForm /> : <AdminLogin />
                  }
                />
                <Route
                  path="UpdateMedbrainixBlog/:id"
                  element={
                    isAdmin ? <MedBrainixBlogForm /> : <AdminLogin />
                  }
                />

                <Route
                  path="/Admin-portfolio"
                  element={
                    isAdmin ? <PortfolioList /> : <AdminLogin />
                  }
                />
                <Route
                  path="/Admin-portfolio-add-animation"
                  element={
                    isAdmin ? <AddAnimation /> : <AdminLogin />
                  }
                />

                <Route
                  path="UpdateAnimation/:id"
                  element={
                    isAdmin ? <EditAnimation /> : <AdminLogin />
                  }
                />

                <Route
                  path="/Admin-portfolio-add-webbased"
                  element={
                    isAdmin ? <AddWebbased /> : <AdminLogin />
                  }
                />
                <Route
                  path="/Admin-portfolio-add-digital-marketing"
                  element={
                    isAdmin ? <AddDigitalMarketing /> : <AdminLogin />
                  }
                />
                <Route
                  path="/update-digital-marketing/:id"
                  element={
                    isAdmin ? <EditDigitalMarketing /> : <AdminLogin />
                  }
                />

                <Route
                  path="/UpdateWebbased/:id"
                  element={
                    isAdmin ? <EditWebbased /> : <AdminLogin />
                  }
                />

                <Route
                  path="/Admin-portfolio-add-softwares"
                  element={
                    isAdmin ? <AddSoftware /> : <AdminLogin />
                  }
                />

                <Route
                  path="/Updatesoftware/:id"
                  element={
                    isAdmin ? <EditSoftware /> : <AdminLogin />
                  }
                />

                <Route
                  path="/Admin-portfolio-add-SMO-SMM"
                  element={
                    isAdmin ? <AddSMO /> : <AdminLogin />
                  }
                />

                <Route
                  path="/UpdateSMO-SMM/:id"
                  element={
                    isAdmin ? <EditSoftware /> : <AdminLogin />
                  }
                />

                {/* ****Admin Part End****** */}


                {/* {TopSEO compony in india} */}

                <Route path="/city/:city" element={<CityPage />} />

                <Route
                  path="/best-seo-services-in-delhi"
                  element={<DelhiSEO />}
                />
                <Route
                  path="/best-seo-services-in-pune"
                  element={<PuneSEO />}
                />
                <Route
                  path="/best-seo-services-in-mumbai"
                  element={<MumbaiSEO />}
                />
                <Route
                  path="/best-seo-services-in-noida"
                  element={<NoidaSEO />}
                />
                <Route
                  path="/best-seo-services-indore"
                  element={<IndoreSEO />}
                />
                <Route
                  path="/best-seo-services-in-bangalore"
                  element={<BangaloreSEO />}
                />

                <Route path="/city/:city" element={<CountriesPage />} />

                <Route path="/best-seo-services-in-uk" element={<UKSEO />} />
                <Route path="/best-seo-services-in-usa" element={<USASEO />} />
                <Route
                  path="/best-seo-services-in-dubai"
                  element={<DUBAIASEO />}
                />
                <Route
                  path="/best-seo-services-in-australia"
                  element={<AUSTRALIASEO />}
                />
                <Route path="/best-seo-services-in-uae" element={<UAESEO />} />
              </Routes>
            </Suspense>
          </div>
        </div>

        {/* Chat Bot Icon  */}
        <div>
          <ChatBotComponent />
        </div>

        {/* Whatsapp icon button */}
        <Whatsappicon />
        <ScrollToTop />
        <MouseMove />
        </div>
      </>
    </HelmetProvider>
  );
}

export default App;
